"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumOffSheetConnectorGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const project_1 = require("../../project");
class AltiumOffSheetConnectorGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, hierarchy) {
        if (this.config.mode === project_1.HierarchyMode.Flat || this.config.mode === project_1.HierarchyMode.Global) {
            this.mergeOffSheetConnectorsGlobally(manager, hierarchy);
        }
        else {
            this.mergeOffSheetConnectorsHierarchically(manager, hierarchy);
        }
        return manager;
    }
    mergeOffSheetConnectorsGlobally(manager, hierarchy) {
        const offSheetGroups = new Map();
        for (const group of manager.findGroupsWithLabel('off-sheet-connector')) {
            const offSheetLabels = group.getNetLabels().filter((label) => label.labelType === 'off-sheet-connector');
            for (const label of offSheetLabels) {
                if (!label.formattedLabel) {
                    continue;
                }
                const connectorName = label.formattedLabel;
                if (!offSheetGroups.has(connectorName)) {
                    offSheetGroups.set(connectorName, new Set());
                }
                offSheetGroups.get(connectorName).add(group);
            }
        }
        for (const groups of offSheetGroups.values()) {
            if (groups.size <= 1) {
                continue;
            }
            const groupsArray = Array.from(groups);
            manager.mergeGroups(...groupsArray);
        }
        for (const child of hierarchy.children) {
            this.mergeOffSheetConnectorsGlobally(manager, child);
        }
    }
    mergeOffSheetConnectorsHierarchically(manager, hierarchy) {
        const offsheetConnectors = new Map();
        for (const group of manager.findGroupsWithLabel('off-sheet-connector')) {
            let isInThisHierarchy = false;
            for (const [instance] of group.getNets()) {
                if (instance.pathUniqueId === hierarchy.pathUniqueId ||
                    instance.pathUniqueId.startsWith(hierarchy.pathUniqueId + '/')) {
                    isInThisHierarchy = true;
                    break;
                }
            }
            if (!isInThisHierarchy) {
                continue;
            }
            for (const label of group.getNetLabels()) {
                if (label.labelType === 'off-sheet-connector') {
                    if (!label.formattedLabel) {
                        continue;
                    }
                    if (!offsheetConnectors.has(label.formattedLabel)) {
                        offsheetConnectors.set(label.formattedLabel, []);
                    }
                    offsheetConnectors.get(label.formattedLabel).push(group);
                }
            }
        }
        for (const groups of offsheetConnectors.values()) {
            if (groups.length <= 1) {
                continue;
            }
            const uniqueGroups = Array.from(new Set(groups));
            if (uniqueGroups.length <= 1) {
                continue;
            }
            manager.mergeGroups(...uniqueGroups);
        }
        for (const child of hierarchy.children) {
            this.mergeOffSheetConnectorsHierarchically(manager, child);
        }
    }
}
exports.AltiumOffSheetConnectorGroupingRule = AltiumOffSheetConnectorGroupingRule;
//# sourceMappingURL=AltiumOffSheetConnectorGroupingRule.js.map